import Card from "./Card";
import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import { useDeferredValue } from "react";
export default function CardsList({ cards, title }) {
  const deferredCards = useDeferredValue(cards);
  if (!deferredCards?.data.length) return null;
  return (
    <>
      <h2 className={classes["list-title"]}>{title}</h2>
      <ul className={classes.cards}>
        {deferredCards.data.map((card) => (
          <li key={uuid()}>
            <Card card={card} />
          </li>
        ))}
      </ul>
    </>
  );
}
